"use client";

import { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import Link from "@/components/Link";
import ExperienceCardV2, { type ExperienceTourV2 } from "@/app/(main)/components/ExperienceCardV2";

export default function ExperienceGrid({
  tours,
  slug,
  filterDest,
}: {
  tours: ExperienceTourV2[];
  slug: string;
  filterDest: string;
}) {
  const searchParams = useSearchParams();
  const currentFilter = searchParams.get("destination") ?? "";
  
  const [prevFilter, setPrevFilter] = useState(filterDest);
  const [visible, setVisible] = useState(true);
  const [displayedTours, setDisplayedTours] = useState(tours);

  if (currentFilter !== prevFilter) {
    setPrevFilter(currentFilter);
    setVisible(false);
  }

  // Also sync tours purely during render if we're not fading out/in, but the parent data changed
  if (visible && displayedTours !== tours) {
    setDisplayedTours(tours);
  }

  useEffect(() => {
    if (!visible) {
      const timer = setTimeout(() => {
        setDisplayedTours(tours);
        setVisible(true);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [visible, tours]);

  return (
    <div
      className="row g-4"
      style={{
        opacity: visible ? 1 : 0.15,
        transition: "opacity 0.3s ease-in-out",
        minHeight: "200px",
      }}
    >
      {displayedTours.length > 0 ? (
        displayedTours.map((tour, i) => (
          <div key={tour.id} className="col-sm-6">
            <ExperienceCardV2 tour={tour} index={i} />
          </div>
        ))
      ) : (
        <div className="col-12 text-center py-5">
          <div className="mb-4">
            <i className="fa-light fa-binoculars fa-4x text-theme"></i>
          </div>
          <p className="blog-text mb-4">
            No experiences found
            {filterDest ? ` in ${filterDest}` : ""}.
          </p>
          <Link
            href={`/experiences/region/${slug}`}
            className="th-btn style1 th-icon"
            title="View all experiences"
          >
            View All Experiences
          </Link>
        </div>
      )}
    </div>
  );
}
